<template>
  <div v-if="loading" class="custom-global-skeleton tw-w-full tw-h-full"></div>
  <div v-else>
    <div
      class="tw-px-[20px] tw-pt-[20px] tw-pb-[10px] tw-flex tw-items-center tw-justify-between tw-h-[46px]"
    >
      <div
        id="scan-mini-dash-card-title"
        class="tw-text-base tw-font-semibold tw-w-full tw-text-[#211F58]"
      >
        {{ getComponentUiText("app-scan-scanning-action-table-label-scans-1") }}
      </div>
    </div>
    <div
      class="tw-px-[20px] tw-py-4 tw-flex tw-items-center tw-justify-between tw-h-[45px]"
    >
      <div class="tw-text-[12px] tw-font-medium">
        {{ getComponentUiText("app-scan-scanning-total-scans-1") }}
      </div>
      <div class="tw-text-[13px] tw-font-semibold tw-text-[#878787]">
        {{ scanCounts.scansCountTotal }}
      </div>
    </div>
    <div
      class="tw-px-[20px] tw-py-4 tw-flex tw-items-center tw-justify-between tw-border-t-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] tw-h-[45px]"
    >
      <div class="tw-text-[12px] tw-font-medium">
        {{
          getComponentUiText(
            "app-assess-recommendations-cyber-health-score-sub-title-1",
          )
        }}
      </div>
      <div class="tw-text-[13px] tw-font-semibold tw-text-[#878787]">
        {{ scanCounts.scansCountCurrent }}
      </div>
    </div>

    <div
      class="tw-flex tw-justify-between tw-grid-cols-3 tw-border-t-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] tw-px-[20px] tw-py-4"
      style="line-height: 16px"
    >
      <div class="tw-col-span-1 tw-text-[12px] tw-font-medium">
        {{ getComponentUiText("app-scan-scanning-scan-targets-1") }}
      </div>
      <div class="tw-col-span-2 tw-text-end">
        <span class="tw-text-[13px] tw-font-semibold tw-text-[#878787]">{{
          scanTargetsCountsDomains?.scansTargetsTypeCounts[0].count +
          scanTargetsCountsWebService?.scansTargetsTypeCounts[0].count
        }}</span>
        <span
          class="tw-mx-[15px] tw-text-[13px] tw-font-medium tw-text-[#B7B7B7]"
        >
          {{ getComponentUiText("app-scan-scanning-domains-1") }}:
          {{ scanTargetsCountsDomains.scansTargetsTypeCounts[0].count }}
        </span>
        <span class="tw-text-[13px] tw-font-medium tw-text-[#B7B7B7]">
          {{ getComponentUiText("app-scan-scanning-web-services-1") }}:
          {{ scanTargetsCountsWebService.scansTargetsTypeCounts[0].count }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getComponentUiText } from "@/utils/utilities";
import { computed } from "vue";
import store from "@/store";

const props = defineProps({
  loading: {
    type: Boolean,
    default: true,
  },
});

const scanCounts = computed(() => store.getters["Scanning/GET_SCAN_COUNTS"]);

const scanTargetsCountsDomains = computed(
  () => store.getters["Scanning/GET_SCAN_TARGETS_COUNTS_DOMAINS"],
);

const scanTargetsCountsWebService = computed(
  () => store.getters["Scanning/GET_SCAN_TARGETS_COUNTS_WEB_SERVICE"],
);
</script>
